module.exports = __webpack_public_path__ + "img/knue_main1.f7e238db.jpg";